export const isMobileDevice = () => {
  const userAgent = navigator.userAgent

  return /iPad|iPhone|iPod/.test(userAgent) || /android/i.test(userAgent)
}
